import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./store/index";
import { LandingPage } from "./pages/Landing-Page";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";
import { Login } from "./pages/login";
import MyPlans from "./pages/my-plans/index";
import { Register } from "./pages/Register";
import { VerifyPage } from "./pages/Verify-Page";
import { ForgotPassword } from "./pages/Forgot-Password/index.jsx";
import { ChangePassword } from "./pages/Change-Password/index.jsx";
import MainLayout from "./Layouts/MainLayout";
import Users from "./pages/Users";
import SharePlan from "./pages/SharePlan";
import { ToastContainer, toast } from "react-toastify";
import { Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddUser from "./pages/Users/AddUser";
import "./toast.css";
import AddPlan from "./pages/my-plans/AddPlan";
import ViewPlan from "./pages/my-plans/ViewPlan";
import ProjectSharePlan from "./pages/SharePlan/shareplan.jsx";
import { Profile } from "./pages/Users/Profile.jsx";
import PrivateRoutesElement from "../src/PrivateRoutes";
import EmptyPage from "./pages";
import Templates from "./pages/Template/index.jsx";
import ErrorPage from "./pages/ErrorPage.jsx";
import ViewTemplate from "./pages/Template/ViewTemplate.jsx";
import Reports from "./pages/Reports/index.jsx";
import HealthReport from "./pages/Reports/HealthReport.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import AnalysisDashboard from "./pages/ScheduleAnalysisDashboard/index.js";
import AnalysisReport from "./pages/ScheduleAnalysisDashboard/AnalysisReport.js";
import ViewResource from "./pages/my-plans/Resource.jsx";
import { AdminMain } from "./pages/admin/main/index.jsx";
import { AdminDashboard } from "./pages/admin/dashboard/index.jsx";
import { IssueLog } from "./pages/admin/issue-log/index.jsx";
import { ManageUsers } from "./pages/admin/manage-users/index.jsx";
import { ManagePlan } from "./pages/admin/manage-plan/index.jsx";
import { ManageTemplate } from "./pages/admin/manage-template/index.jsx";
import { MappingIkn } from "./utils/icon/Private-Pages/Icon.js";
import { Mapping } from "./pages/admin/mapping/index.jsx";
import { SeparateMapping } from "./pages/admin/separate-mapping/index.jsx";
import { AdminViewTemplate } from "./pages/admin/view-template/index.jsx";
import { AdminCustomSubscription } from "./pages/admin/custom-subscription/index.jsx";
import { AdminSettings } from "./pages/admin/settings/index.jsx";
import { AdminNewSubscription } from "./pages/admin/new-subscription/index.jsx";
import { NewTemplate } from "./pages/admin/new-template/index.jsx";
import ExpireLink from "./pages/ExpireLink.jsx";
import PlanDashboard from "./pages/my-plans/PlanDashboard.jsx";
import { AdminViewPlan } from "./pages/admin/view-plan/index.jsx";
import Pricing from "./pages/Pricing.jsx";
const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />, // Public route
  },
  {
    path: "/Reg",
    element: <Register />, // Public route
  },
  {
    path: "/Login",
    element: <Login />, // Public route
  },
  {
    path: "/Otp",
    element: <VerifyPage />, // Public route
  },
  {
    path: "/ForgotPassword",
    element: <ForgotPassword />, // Public route
  },
  {
    path: "/ChangePassword",
    element: <ChangePassword />, // Public route
  },
  {
    path: "/404",
    element: <PrivateRoutesElement element={<ErrorPage />} />,
  },
  {
    path: "/Expired",
    element: <PrivateRoutesElement element={<ExpireLink />} />,
  },
  {
    path: "/home",
    element: <MainLayout />, // Protected route
    // element: <PrivateRoute element={Main_2} />, // Protected route
    children: [
      {
        path: "/home/myplans",
        element: <PrivateRoutesElement element={<MyPlans />} />, // Protected route
      },
      {
        path: "/home/createplan",
        element: <PrivateRoutesElement element={<AddPlan />} />, // Protected route
      },
      {
        path: "/home/ViewResource",
        element: <PrivateRoutesElement element={<ViewResource />} />, // Protected route
      },
      {
        path: "/home/viewplan",
        element: <PrivateRoutesElement element={<ViewPlan />} />, // Protected route
      },

      {
        path: "/home/users",
        element: <PrivateRoutesElement element={<Users />} />, // Protected route
      },
      {
        path: "/home/adduser",
        element: <PrivateRoutesElement element={<AddUser />} />, // Protected route
      },
      {
        path: "/home/shareplan",
        element: <PrivateRoutesElement element={<SharePlan />} />, // Protected route
      },
      {
        path: "/home/profile",
        element: <PrivateRoutesElement element={<Profile />} />, // Protected route
      },
      {
        path: "/home/plan-share-screen",
        element: <PrivateRoutesElement element={<ProjectSharePlan />} />, // Protected route
      },
      {
        path: "/home/analysis",
        element: <PrivateRoutesElement element={<AnalysisDashboard />} />,
      },
      {
        path: "/home/AnalysisReport",
        element: <PrivateRoutesElement element={<AnalysisReport />} />,
      },
      {
        path: "/home/reports",
        element: <PrivateRoutesElement element={<Reports />} />,
      },
      {
        path: "/home/healthreport",
        element: <PrivateRoutesElement element={<HealthReport />} />,
      },
      {
        path: "/home/subscription",
        element: <PrivateRoutesElement element={<Pricing />} />,
      },
      {
        path: "/home/templates",
        element: <PrivateRoutesElement element={<Templates />} />,
      },
      {
        path: "/home/plandashboard",
        element: <PrivateRoutesElement element={<PlanDashboard />} />,
      },
      {
        path: "/home/viewtemplate",
        element: <PrivateRoutesElement element={<ViewTemplate />} />, // Protected route
      },
      {
        path: "/home/videos",
        element: <PrivateRoutesElement element={<EmptyPage />} />,
      },
      {
        path: "/home/dashboard",
        element: <PrivateRoutesElement element={<Dashboard />} />,
      },
    ],
  },
  {
    path: "/admin",
    element: <PrivateRoutesElement element={<AdminMain/>} />, // Protected route
    children: [
      {
        path: "",
        element: <PrivateRoutesElement element={<AdminDashboard />} />, // Protected route
      },
      {
        path: "issue-log",
        element: <PrivateRoutesElement element={<IssueLog />} />, // Protected route
      },
      {
        path: "manage-users",
        element: <PrivateRoutesElement element={<ManageUsers />} />, // Protected route
      },
      {
        path: "manage-plan",
      element: <PrivateRoutesElement element={<ManagePlan />} />, // Protected route
      },
      {
        path: "manage-templates",
        element: <PrivateRoutesElement element={<ManageTemplate />} />, // Protected route
      },
      {
        path: "mapping",
        element: <PrivateRoutesElement element={<Mapping />} />, // Protected route
      },
      {
        path: "separate-mapping",
        element: <PrivateRoutesElement element={<SeparateMapping />} />, // Protected route
      },
      {
        path: "settings",
        element: <PrivateRoutesElement element={<AdminSettings />} />, // Protected route
      },
      {
        path: "view-plan",
        element: <PrivateRoutesElement element={<AdminViewPlan />} />, // Protected route
      },
      {
        path: "view-template",
        element: <PrivateRoutesElement element={<AdminViewTemplate />} />, // Protected route
      },
      {
        path: "custom-subscription",
        element: <PrivateRoutesElement element={<AdminCustomSubscription />} />, // Protected route
      },
      {
        path: "new-subscription",
        element: <PrivateRoutesElement element={<AdminNewSubscription />} />, // Protected route
      },
      {
        path: "new-template",
        element: <PrivateRoutesElement element={<AddPlan />} />, // Protected route
      },
      {
        path: "new-template",
        element: <PrivateRoutesElement element={<NewTemplate />} />, // Protected route
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to='/' />, // Redirect unknown routes to home
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
        <ToastContainer
          position='bottom-right'
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          // closeOnClick={true}
          theme='light'
          transition={Slide}
          className='custom-toast-container'
        />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
